import axios from 'axios';

export default class ApiService {
    constructor() {
        this.token = document.querySelector('meta[name="csrf-token"]').content;
        this.baseUrl = '/api';
    }

    /**
     * Make a GET HTTP request to the given url.
     * Also pass the application token int the request headers.
     *
     * @param {string} url The url you want to request.
     * @returns {Promise<any>} The promise returned by the HTTP request.
     */
    get(url) {
        return axios.get(this.baseUrl + url, {
            headers: {
                'X-CSRF-TOKEN': this.token,
            },
        });
    }

    /**
     * Make a POST HTTP request to the given url.
     * Also pass the application token int the request headers.
     *
     * @param {string} url The url you want to request.
     * @param {Object} payload The payload of the request. Must be an object containing all the attributes you want to send.
     *
     * @returns {Promise<any>} The promise returned by the HTTP request.
     */
    post(url, payload) {
        return axios.post(this.baseUrl + url, payload, {
            headers: {
                'X-CSRF-TOKEN': this.token,
            },
        });
    }

    /**
     * Make a PUT HTTP request to the given url.
     * Also pass the application token int the request headers.
     *
     * @param {string} url The url you want to request.
     * @param {Object} payload The payload of the request. Must be an object containing all the attributes you want to send.
     *
     * @returns {Promise<any>} The promise returned by the HTTP request.
     */
    put(url, payload) {
        return axios.put(this.baseUrl + url, payload, {
            headers: {
                'X-CSRF-TOKEN': this.token,
            },
        });
    }

    /**
     * Make a DELETE HTTP request to the given url.
     * Also pass the application token int the request headers.
     *
     * @param {string} url The url you want to request.
     * @returns {Promise<any>} The promise returned by the HTTP request.
     */
    delete(url) {
        return axios.delete(this.baseUrl + url, {
            headers: {
                'X-CSRF-TOKEN': this.token,
            },
        });
    }
}
